import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

// Components
import { TitleDefault, TitleAlt, ButtonSecondary } from 'components/Elements'

// Language
import { getLanguage } from 'services/language'

// CSS
import './Whitepaper.scss'

const Whitepaper = () => {
  const { whitepaperNL, whitepaperEN } = useStaticQuery(graphql`
    {
      whitepaperNL: wordpressWpComponenten(
        slug: { eq: "whitepaper" }
        wpml_current_locale: { eq: "nl_NL" }
      ) {
        ...whitepaperContent
      }
      whitepaperEN: wordpressWpComponenten(
        slug: { eq: "whitepaper" }
        wpml_current_locale: { eq: "en_US" }
      ) {
        ...whitepaperContent
      }
    }

    fragment whitepaperContent on wordpress__wp_componenten {
      acf {
        textTop: text_top
        textBottom: text_bottom
        buttonText: button_text
        buttonLocation: button_location
      }
    }
  `)

  const language = getLanguage()
  const whitepaperContent = language === 'nl_NL' ? whitepaperNL : whitepaperEN

  return (
    <div className="whitepaper color-background-contrast">
      <div className="container py-4">
        <div className="row py-2">
          <div className="col-12 col-lg-8 text-center">
            <TitleDefault className="color-text-light">
              <div
                dangerouslySetInnerHTML={{
                  __html: whitepaperContent.acf.textTop,
                }}
              />
            </TitleDefault>
            <TitleAlt className="color-text-light">
              <div
                dangerouslySetInnerHTML={{
                  __html: whitepaperContent.acf.textBottom,
                }}
              />
            </TitleAlt>
          </div>
          <div className="col-12 col-lg-4 text-center d-lg-flex justify-content-end align-items-center mt-4 mt-lg-0">
            <ButtonSecondary to={whitepaperContent.acf.buttonLocation}>
              <div
                dangerouslySetInnerHTML={{
                  __html: whitepaperContent.acf.buttonText,
                }}
              />
            </ButtonSecondary>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Whitepaper
